import api from "./api";

/**
 * Envia status de texto para o WhatsApp
 * @param {number} whatsappId - ID da conexão do WhatsApp
 * @param {string} content - Conteúdo do status
 * @param {string} backgroundColor - Cor de fundo (hex) - opcional
 * @param {number} font - Tipo de fonte (0-5) - opcional
 */
export const sendTextStatus = async (whatsappId, content, backgroundColor = "#000000", font = 0) => {
  try {
    const { data } = await api.post(`/status/${whatsappId}`, {
      type: "text",
      content,
      backgroundColor,
      font,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Envia status com imagem para o WhatsApp
 * @param {number} whatsappId - ID da conexão do WhatsApp
 * @param {File} file - Arquivo de imagem
 * @param {string} caption - Legenda da imagem - opcional
 */
export const sendImageStatus = async (whatsappId, file, caption = "") => {
  try {
    const formData = new FormData();
    formData.append("type", "image");
    formData.append("media", file);
    if (caption) {
      formData.append("caption", caption);
    }

    const { data } = await api.post(`/status/${whatsappId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Envia status com vídeo para o WhatsApp
 * @param {number} whatsappId - ID da conexão do WhatsApp
 * @param {File} file - Arquivo de vídeo
 * @param {string} caption - Legenda do vídeo - opcional
 */
export const sendVideoStatus = async (whatsappId, file, caption = "") => {
  try {
    const formData = new FormData();
    formData.append("type", "video");
    formData.append("media", file);
    if (caption) {
      formData.append("caption", caption);
    }

    const { data } = await api.post(`/status/${whatsappId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Lista os status do WhatsApp (futura implementação)
 * @param {number} whatsappId - ID da conexão do WhatsApp
 */
export const listStatus = async (whatsappId) => {
  try {
    const { data } = await api.get(`/status/${whatsappId}`);
    return data;
  } catch (error) {
    throw error;
  }
};
